const widgetServices = ['customerBase', 'paymentLinks', 'signupForms']
const baseUrl = process.env.VUE_APP_CLIENT_BASE
const hostedBaseUrl = process.env.VUE_APP_PAY_BASE
// const customEvents = ['onSubscriptionSuccess']
const settings = window.piriodSettings
const referrer = window.location.href
const urlParams = new URLSearchParams(window.location.search)

const parseSettings = () => {
  // customer base settings params
  const pbase = urlParams.get('pbase')
  const psession = urlParams.get('psession')

  // payment links settings params
  const plinkid = urlParams.get('plinkid')

  // signup forms or payment links settings params
  const ppublishablekey = urlParams.get('ppublishablekey')

  // evaluate service & set settings
  switch (settings && settings.service) {
    case 'customerBase':
      if (pbase) {
        settings.customerBaseId = pbase
      }

      if (psession) {
        settings.sessionKey = psession
      }

      break

    case 'paymentLinks':
      if (ppublishablekey) {
        settings.linkId = plinkid
      }

      break

    case 'signupForms':
      if (ppublishablekey) {
        settings.publishableKey = ppublishablekey
      }

      break
  }
}

const validateSettings = () => {
  if (!settings) {
    console.error('window.piriodSettings is not defined')
    return false
  }
  if (typeof settings !== 'object') {
    console.error('window.piriodSettings must be object')
    return false
  }

  const service = settings.service

  if (!service) {
    console.error('service is not defined in window.piriodSettings')
    return false
  }
  if (!widgetServices.includes(service)) {
    console.error(service, 'Is not available service.')
    return false
  }

  // assign settings values based on service
  switch (service) {
    case 'customerBase':
      if (!settings.customerBaseId) {
        console.error('customerBaseId is not defined in window.piriodSettings')
        return false
      }

      break

    case 'paymentLinks':
      if (!settings.linkId) {
        console.error('linkId is not defined in window.piriodSettings')
        return false
      }

      break

    case 'signupForms':
      if (!settings.publishableKey) {
        console.error('publishableKey is not defined in window.piriodSettings')
        return false
      }

      break
  }

  return true
}

/**
 * Construct URL to load iframe
 * @returns {string} url
 */
const getSrc = () => {
  let src = baseUrl

  switch (settings.service) {
    case 'customerBase':
      src += '/customer_base/' + settings.customerBaseId

      if (settings.sessionKey) {
        src += '/' + settings.sessionKey
      }

      // add referrer
      if (referrer && !referrer.includes(hostedBaseUrl)) {
        src += '?referrer=' + referrer
      }

      break

    case 'paymentLinks':
      src += '/payment_links/links/' + settings.linkId

      // add referrer
      if (referrer) {
        src += '?referrer=' + referrer
      }

      if (urlParams.get('payment_status')) {
        src += referrer ? '&' : '?'
        src += 'ppaymentstatus=' + urlParams.get('payment_status')
      }

      break

    case 'signupForms':
      src += '/signup_forms/' + settings.publishableKey

      // add referrer
      if (referrer) {
        src += '?referrer=' + referrer
      }

      // add source status
      if (urlParams.get('source_status')) {
        src += referrer ? '&' : '?'
        src += 'psourcestatus=' + urlParams.get('source_status')
      }

      break
  }

  return src
}

const getFrame = () => {
  return document.getElementById('piriod-frame')
}

const triggerEvent = (e) => {
  if (e.origin === baseUrl) {
    // resize
    if (e.data.event === 'widget_resize') {
      const frame = getFrame()
      frame.height = e.data.value
    } else if (e.data.event === 'widget_redirect') {
      // redirect
      window.location.replace(e.data.value)
    }

    // custom events
  }
}

const install = () => {
  const e = document.getElementById('piriod-widget')
  if (!e) {
    console.error('Missing <div id="piriod-widget"></div>, create this to mount.')
    return false
  }

  const i = document.createElement('iframe')
  i.src = getSrc()
  i.id = 'piriod-frame'
  i.width = '100%'
  i.height = '900'
  i.style = 'border:none'

  e.appendChild(i)

  window.addEventListener('message', triggerEvent)

  // set settings
  i.addEventListener('load', function () {
    i.contentWindow.postMessage({
      event: 'set_options',
      value: settings.options
    }, '*')
  }, false)

  // set context
  i.addEventListener('load', function () {
    i.contentWindow.postMessage({
      event: 'set_context',
      value: settings.context
    }, '*')
  }, false)
}

(function () {
  parseSettings()
  if (!validateSettings()) {
    return
  }
  install()
})()
